export enum CreditErrorType {
  NONE = 'NONE',
  ERROR = 'ERROR',
  HARDSTOP = 'HARDSTOP',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  UNKNOWN = 'UNKNOWN'
}